import {View, Text, Modal, TouchableOpacity, Image} from 'react-native';
import React from 'react';
import Feather from 'react-native-vector-icons/Feather';
import {Colors} from '../../../../constants/Colors';

import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import {styles} from './styles';
import CheckBox from '../../../../components/CheckBox/CheckBox';
import {Images} from '../../../../constants/Images';

interface IModalFilter {
  visible: boolean;
  onRequestClose: () => void;
  onPress: () => void;
}

const AcceptedTermModal = ({
  visible,
  onRequestClose,
  onPress,
}: IModalFilter) => {
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}>
      <View style={styles.containerModal}>
        <View style={styles.containerFilter}>
          <View style={styles.spaceHorizontal}>
            <TouchableOpacity onPress={onRequestClose}>
              <Feather
                name="x"
                size={32}
                color={Colors.lightGray}
                style={styles.iconX}
              />
            </TouchableOpacity>
          </View>
          <Image
            source={Images.check}
            style={{
              alignSelf: 'center',
              marginBottom: 30,
              marginTop: 20,
            }}
          />
          <Text
            style={{
              fontSize: 22,
              lineHeight: 26,
              color: 'black',
              textAlign: 'center',
              //   maxWidth: 200,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 20,
            }}>
            Você aderiu a campanha!
          </Text>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 19,
              color: Colors.GrayPallete.lightgrayThree,
              fontFamily: 'TCCC-UnityHeadline Regular',
              alignSelf: 'center',
              marginTop: 20,
              maxWidth: 250,
              textAlign: 'center',
            }}>
            Nome da campanha colocar aqui nesta linha
          </Text>
          <View style={styles.containerDrop}></View>
          <View style={styles.containerButton}>
            <ButtonComponent
              title="Consultar detalhes da campanha"
              width="100%"
              onPress={onPress}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default AcceptedTermModal;
